import { Component, Inject, ViewEncapsulation } from '@angular/core';
import {
  MatLegacySnackBar as MatSnackBar,
  MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA,
  MatLegacySnackBarRef as MatSnackBarRef,
} from '@angular/material/legacy-snack-bar';

export interface NoticeSnackbarData {
  title: string;
  text?: string;
  /** Part of `text` shown bold in the accent colour (e.g. an email address). */
  highlight?: string;
  icon?: string;
  /**
   * success: done as asked. neutral: a reversible removal. warning: done, but
   * something needs attention. error: failed.
   */
  tone?: NoticeTone;
}

export type NoticeTone = 'success' | 'neutral' | 'warning' | 'error';

const TONE_ICONS: Record<NoticeTone, string> = {
  success: 'check_circle',
  neutral: 'delete_outline',
  warning: 'warning_amber',
  error: 'error_outline',
};

/** The app's card-style snack bar: icon, title, optional detail, dismiss. */
@Component({
  selector: 'app-notice-snackbar',
  templateUrl: './notice-snackbar.component.html',
  styleUrls: ['./notice-snackbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NoticeSnackbarComponent {
  static open(
    snackBar: MatSnackBar,
    data: NoticeSnackbarData,
    duration = data.tone === 'error' || data.tone === 'warning' ? 8000 : 5000,
  ): void {
    snackBar.openFromComponent(NoticeSnackbarComponent, {
      data,
      duration,
      panelClass: 'notice-snackbar',
    });
  }

  readonly icon: string;
  readonly textBefore: string;
  readonly textAfter: string;
  readonly highlighted: boolean;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: NoticeSnackbarData,
    public snackBarRef: MatSnackBarRef<NoticeSnackbarComponent>,
  ) {
    this.icon = data.icon ?? TONE_ICONS[data.tone ?? 'success'];
    const at = data.highlight ? (data.text?.indexOf(data.highlight) ?? -1) : -1;
    this.highlighted = at >= 0;
    this.textBefore = this.highlighted ? data.text.slice(0, at) : data.text;
    this.textAfter = this.highlighted
      ? data.text.slice(at + data.highlight.length)
      : '';
  }
}
